import { useEffect, useState } from "react";
import logo from "../assets/media/logo.png";
import { useSnackbar } from "notistack";
const DEV_PASSWORD = "121";

export default function Authorized() {
  const [showPassword, setShowPassword] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [password, setPassword] = useState("");
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // If already authorized, don't block DevTools
      if (authorized) return;

      // F12
      if (e.key === "F12") {
        e.preventDefault();
        setShowPassword(true);
        return;
      }

      // Ctrl + Shift + I
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") {
        e.preventDefault();
        setShowPassword(true);
        return;
      }

      // Ctrl + Shift + J
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") {
        e.preventDefault();
        setShowPassword(true);
        return;
      }

      // Ctrl + Shift + C
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "c") {
        e.preventDefault();
        setShowPassword(true);
        return;
      }
    };

    // Right click
    const handleContextMenu = (e) => {
      if (authorized) return;

      e.preventDefault();
      setShowPassword(true);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("contextmenu", handleContextMenu);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [authorized]);

  const handleSubmit = () => {
    if (password === DEV_PASSWORD) {
      setAuthorized(true);
      setShowPassword(false);
      setPassword("");
      enqueueSnackbar("Developer access granted. You can now open Inspect.", {
        variant: "success",
      });
    } else {
      enqueueSnackbar("Incorrect password", { variant: "error" });
      setPassword("");
      // Clear all data saved in localStorage
      localStorage.clear();

      // Refresh the page
      window.location.reload();
    }
  };

  return (
    <>
      {/* Your application */}

      {showPassword && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background:
              "radial-gradient(circle at 50% 40%, rgba(80, 80, 80, 0.18), transparent 45%), #050505",
            zIndex: 999999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            fontFamily:
              "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "420px",
              background:
                "linear-gradient(145deg, rgba(25,25,25,0.98), rgba(10,10,10,0.98))",
              border: "1px solid rgba(255,255,255,0.10)",
              borderRadius: "20px",
              padding: "36px",
              boxShadow:
                "0 25px 80px rgba(0,0,0,0.75), 0 0 40px rgba(255,255,255,0.03)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Top Glow */}
            <div
              style={{
                position: "absolute",
                top: "-100px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "220px",
                height: "220px",
                background: "rgba(255,255,255,0.06)",
                filter: "blur(70px)",
                borderRadius: "50%",
                pointerEvents: "none",
              }}
            />

            {/* Logo */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "28px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <img
                src={logo}
                alt="Exbotix"
                style={{
                  width: "150px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Lock Icon */}
            <div
              style={{
                width: "58px",
                height: "58px",
                margin: "0 auto 20px",
                borderRadius: "16px",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.10)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "25px",
                color: "#fff",
                position: "relative",
                zIndex: 1,
              }}
            >
              🔐
            </div>

            {/* Heading */}
            <div
              style={{
                textAlign: "center",
                position: "relative",
                zIndex: 1,
              }}
            >
              <h2
                style={{
                  color: "#fff",
                  margin: "0 0 10px",
                  fontSize: "24px",
                  fontWeight: 700,
                  letterSpacing: "-0.5px",
                }}
              >
                Developer Access
              </h2>

              <p
                style={{
                  color: "#8b8b8b",
                  margin: "0 0 28px",
                  fontSize: "14px",
                  lineHeight: 1.6,
                }}
              >
                This area is restricted to authorized
                <br />
                Exbotix developers only.
              </p>
            </div>

            {/* Password Label */}
            <label
              style={{
                display: "block",
                color: "#cfcfcf",
                fontSize: "13px",
                fontWeight: 500,
                marginBottom: "8px",
              }}
            >
              Developer Password
            </label>

            {/* Password Input */}
            <div
              style={{
                position: "relative",
                marginBottom: "18px",
              }}
            >
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
                autoFocus
                style={{
                  width: "100%",
                  height: "52px",
                  boxSizing: "border-box",
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: "10px",
                  outline: "none",
                  padding: "0 15px",
                  color: "#fff",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                }}
              />
            </div>

            {/* Continue Button */}
            <button
              onClick={handleSubmit}
              style={{
                width: "100%",
                height: "52px",
                border: "none",
                borderRadius: "10px",
                background: "#fff",
                color: "#000",
                fontSize: "14px",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e5e5e5";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#fff";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Continue to Developer Tools
            </button>

            {/* Footer */}
            <div
              style={{
                textAlign: "center",
                marginTop: "22px",
                color: "#555",
                fontSize: "11px",
              }}
            >
              🔒 Authorized access only
            </div>
          </div>
        </div>
      )}
    </>
  );
}
